"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var customElement_1 = require("../customElement");
var jsx_to_idom_1 = require("@wk/jsx-to-idom");
var nativeApi_1 = require("../utils/nativeApi");
var consts_1 = require("../utils/consts");
var beforeRenderNativeApi;
/**
 * Render function for our web component.
 */
exports.render = jsx_to_idom_1.renderFactory({
    beforeRender: function (vnode) {
        // if we want to render slots we have to:
        // - block native api for allow remove element from parent
        // - provide the childNodes for slots
        if (vnode.tag === consts_1.SLOT_TAG_NAME) {
            beforeRenderNativeApi = nativeApi_1.isNativeApiExposed();
            nativeApi_1.exposeNativeApi(false);
            vnode.attributes = vnode.attributes || {};
            vnode.attributes['childNodes'] = vnode.attributes.name ?
                vnode.context.data.slots[vnode.attributes.name] :
                vnode.context.data.slots[consts_1.UNNAMED_SLOT_KEY];
        }
    },
    afterCreateNode: function (vnode, element) {
        // if we are rendering nested webcomponent, we should provide fake api to apply rendering
        // on render-root instead of element itself
        if (element instanceof customElement_1.CustomElement && (!vnode.context.data || vnode.context.data.component !== element)) {
            element.beforeRenderNativeApi = nativeApi_1.isNativeApiExposed();
            nativeApi_1.exposeNativeApi(false);
        }
        if (element.tagName === 'SLOT') {
            // if slot has childNodes, that is lightDom, we close it so renderer would skip it without issues
            // if slot has no childNodes, that is no lightDom, we open it, so default content will be rendered into slot
            element.__exposeSlotAPI = !vnode.attributes.childNodes;
            if (!vnode.attributes.childNodes) { // so we are rendering default content
                var before_1 = nativeApi_1.isNativeApiExposed();
                nativeApi_1.exposeNativeApi(true);
                Array.prototype.forEach.call(element.childNodes, function (node) {
                    if (node.__unadopt) { // if node is adopted it is lightDom node
                        // we need to remove lightDom nodes, so iDom will not change them
                        // when rendering default content
                        element.removeChild(node);
                    }
                });
                nativeApi_1.exposeNativeApi(before_1);
            }
        }
    },
    afterRender: function (vnode, element) {
        // returning back flag on exit from node
        if (vnode.tag === consts_1.SLOT_TAG_NAME) {
            nativeApi_1.exposeNativeApi(beforeRenderNativeApi);
        }
        else if (element instanceof customElement_1.CustomElement && (!vnode.context.data || vnode.context.data.component !== element)) {
            nativeApi_1.exposeNativeApi(element.beforeRenderNativeApi);
            delete element.beforeRenderNativeApi;
        }
    }
});
